//types
import {IOrganizationEvent} from '@/utils/types';

export const getEventOptions = (events: IOrganizationEvent[] | null) =>
	events?.map((event) => ({id: String(event.id), name: event.name}));

export const getEventById = (events: IOrganizationEvent[], eventId: string) =>
	events.find((event) => event.id === +eventId);
